import { core } from 'etl/core';
import { defaultProps, PageContainerProps } from './PageContainer.type';
import { Button, ButtonType, Spinner } from 'design-system/src/Atoms';
import styles from './PageContainer.module.scss';
import { dashboardRoutes, etlRoutes } from 'etl/types';
import { ProcessRunningModal } from '../ProcessRunningModal/ProcessRunningModal';

export const PageContainer = (props: PageContainerProps) => {
	const { children, ...attributes } = { ...defaultProps, ...props }

	const { logout } = core.useAuthUseCases();
	const { isAuthenticated, authIsLoading } = core.useAuthSelectors();
	const { selectedEtlImport } = core.useEtlDataSelectors();
	const { updateLocation } = core.useNavigationUseCases();

	if (authIsLoading) {
		return <div {...attributes} className={styles.PageContainer}><Spinner size="large" fullscreen /></div>
	}

	return (
		<div {...attributes} className={styles.PageContainer}>
			<ProcessRunningModal />
			{children}
			{isAuthenticated && !authIsLoading && (
				<Button
					type={ButtonType.Link}
					className={styles.LogoutButton}
					onClick={() => logout()}>
					Déconnexion
				</Button>
			)}
			{selectedEtlImport && !location.pathname.includes("dashboard") && (
				<Button
					type={ButtonType.Link}
					className={styles.DashboardButton}
					onClick={() => updateLocation({ pathname: dashboardRoutes.dashboard.path })}>
					Dashboard
				</Button>
			)}
			{selectedEtlImport && location.pathname.includes("dashboard") && (
				<Button
					type={ButtonType.Link}
					className={styles.DashboardButton}
					onClick={() => updateLocation({ pathname: etlRoutes.selectCompetitor.path })}>
					Tunnel ETL
				</Button>
			)}
		</div>
	)
}
